import React, { useState, useEffect } from "react";
import VideoFeed from "./VideoFeed";
import RecordingSelector from "./RecordingSelector";
import { useInstitution } from "../contexts/InstitutionContext";

const PasswordPrompt = ({ onSubmit, error }) => {
  const [password, setPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await onSubmit(password);
    setIsSubmitting(false);
  };

  return (
    <div className="enter-screen">
      <div className="enter-content">
        <h1>Institution Access</h1>
        <p>Enter password to access this institution's coaching feed</p>

        <form
          onSubmit={handleSubmit}
          style={{ marginTop: "20px", width: "100%" }}
        >
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
            disabled={isSubmitting}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginBottom: "10px",
            }}
          />

          {error && (
            <div
              style={{
                color: "#d32f2f",
                fontSize: "14px",
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#ffebee",
                borderRadius: "4px",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="enter-button"
          >
            {isSubmitting ? "Authenticating..." : "Access Feed"}
          </button>
        </form>
      </div>
    </div>
  );
};

function InstitutionFeed() {
  const {
    snippets,
    recordings,
    isLoading,
    error,
    showPasswordPrompt,
    handlePasswordSubmit,
  } = useInstitution();
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [filteredSnippets, setFilteredSnippets] = useState([]);
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    if (recordings.length > 0 && !selectedRecording) {
      setSelectedRecording(recordings[0].id);
    }
  }, [recordings, selectedRecording]);

  useEffect(() => {
    if (selectedRecording) {
      const filtered = snippets.filter(
        (s) => s.recordingId === selectedRecording
      );
      setFilteredSnippets(filtered);
    }
  }, [selectedRecording, snippets]);

  if (showPasswordPrompt) {
    return <PasswordPrompt onSubmit={handlePasswordSubmit} error={error} />;
  }

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        <p>Loading coaching moments...</p>
      </div>
    );
  }

  if (error && !showPasswordPrompt) {
    return (
      <div className="enter-screen">
        <div className="enter-content">
          <h1>Error</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!hasEntered) {
    return (
      <div className="enter-screen">
        <div className="enter-content">
          <h1>Coaching Feed</h1>
          <p>Key coaching moments</p>
          <button className="enter-button" onClick={() => setHasEntered(true)}>
            Enter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <RecordingSelector
        recordings={recordings}
        selectedRecording={selectedRecording}
        onSelectRecording={setSelectedRecording}
      />
      <VideoFeed snippets={filteredSnippets} />
    </div>
  );
}

export default InstitutionFeed;
